import React, {useCallback, useState} from 'react'
import Button from 'react-bootstrap/Button'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import s from './styles/Search.module.scss'
import {AiOutlineSearch} from 'react-icons/ai'
import PropTypes from "prop-types";

export const SearchBar = ({
                              className,
                              label,
                              containerClassName,
                              height,
                              placeholder,
                              showSearchButton = true,
                              searchBarSuggestions,
                              onUseSuggestion,
                              onSearchQueryChange,
                              onSearch,
                          }) => {
    const [query, setQuery] = useState(null);

    const handleChange = useCallback((event) => {
        const newQuery = event.target.value;
        setQuery(newQuery);

        if (onSearchQueryChange) {
            onSearchQueryChange(newQuery);
        }

    }, [onSearchQueryChange]);

    function useSuggestion(event) {
        const suggestion = event.target.textContent
        setQuery(suggestion)
        onUseSuggestion(suggestion)
    }

    function onSearchClick() {
        const finalQuery = query;
        setQuery('')
        handleSearch(finalQuery);
    }

    function onKeyPress(event) {
        if (event.key === 'Enter') {
            const finalQuery = query;
            setQuery('')
            handleSearch(finalQuery);
        }
    }

    function handleSearch(finalQuery) {
        if (onSearch) {
            onSearch(finalQuery)
        } else {
            if (finalQuery && finalQuery.length > 0) {
                const params = new URLSearchParams({
                    query: finalQuery,
                })
                window.location.href = '/search?' + params
            }
        }
    }

    return <div className={`${containerClassName}`}>
        {label && <label style={{marginBottom: '8px'}}>{label}</label>}
        <InputGroup>
            <FormControl autoComplete="off"
                         style={{height: height || 40}}
                         maxLength={255}
                         placeholder={placeholder || "Search a school or student..."}
                         className={`${className}`}
                         value={query || ''}
                         name={"text"}
                         onKeyPress={onKeyPress}
                         onChange={handleChange}/>
            {showSearchButton &&
                <Button style={{height: height, borderTopRightRadius: '10px', borderBottomRightRadius: '10px'}}
                        className='btnFill green' onClick={onSearchClick}>
                    <AiOutlineSearch/>
                </Button>}
        </InputGroup>
        {searchBarSuggestions && searchBarSuggestions.length > 0 && (
            <ul className={`${s.suggestions}`}>
                {searchBarSuggestions.map((suggestion, index) => (
                    <li key={index} style={{borderBottom: '3px', borderColor:'blue'}}>
                        <Button className={`btn-light border-3 ${s.suggestion}`}
                                onClick={useSuggestion}>
                            <>{suggestion}</>
                        </Button>
                    </li>
                ))}
            </ul>
        )}
    </div>
}

SearchBar.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    containerClassName: PropTypes.string,
    height: PropTypes.number,
    placeholder: PropTypes.string,
    showSearchButton: PropTypes.bool,
    searchBarSuggestions: PropTypes.arrayOf(PropTypes.string),
    onSearchQueryChange: PropTypes.func,
    onSearch: PropTypes.func,
    onKeyPress: PropTypes.func
};
